import React from 'react';
import { HomeIcon, DollarSignIcon, ShieldIcon } from 'lucide-react';
export function JealousWhySection() {
  const cards = [{
    icon: HomeIcon,
    title: 'Instant Curb Appeal',
    body: 'Your home will look noticeably cleaner and more impressive from the street after just one visit.'
  }, {
    icon: DollarSignIcon,
    title: '$500 Value for $167',
    body: 'A full front exterior refresh at a fraction of the cost — one of the smartest home upgrades available.'
  }, {
    icon: ShieldIcon,
    title: 'Protect Your Surfaces',
    body: 'Professional cleaning removes harmful grime that causes long-term damage, helping surfaces last longer.'
  }];
  return <section className="w-full py-24 px-4 bg-white" data-id="element-372">
      {/* Before & After Photo */}
      <div className="max-w-7xl mx-auto mb-16" data-id="element-373">
        <p className="text-center mb-4" style={{
        color: '#3B8AC4',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontWeight: 700,
        fontSize: '13px',
        letterSpacing: '1px',
        textTransform: 'uppercase'
      }} data-id="element-374">
          REAL RESULTS
        </p>
        <div className="rounded-[20px] overflow-hidden" style={{
        boxShadow: '0 8px 30px rgba(59,138,196,0.12)'
      }} data-id="element-375">
          <img src="https://cdn.magicpatterns.com/uploads/nudTdTSSgBZVdncXorqzn8/2025-07-31.webp" alt="Before and after driveway cleaning by Blue Cactus Power Washing" className="w-full h-auto object-cover" data-id="element-376" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto" data-id="element-377">
        <div className="text-center mb-16" data-id="element-378">
          <p className="mb-3" style={{
          color: '#3B8AC4',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '13px',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }} data-id="element-379">
            WHY BLUE CACTUS
          </p>
          <h2 className="mb-4" style={{
          color: '#1F2937',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(28px, 4vw, 36px)',
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }} data-id="element-380">
            Your Home Deserves to Shine
          </h2>
          <p style={{
          color: '#4F5B69',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '16px'
        }} data-id="element-381">
            Watch years of dirt, stains, and buildup disappear in a single
            visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-382">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <div key={i} className="group p-8 rounded-[16px] transition-all duration-300 hover:-translate-y-2" style={{
            backgroundColor: '#EDF5FB',
            border: '1px solid transparent'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#FFFFFF';
            e.currentTarget.style.borderColor = '#3B8AC4';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(59,138,196,0.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#EDF5FB';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.boxShadow = 'none';
          }} data-id="element-383">
                <div className="w-14 h-14 rounded-[14px] flex items-center justify-center mb-6" style={{
              backgroundColor: '#3B8AC4'
            }} data-id="element-384">
                  <Icon className="w-6 h-6 text-white" data-id="element-385" />
                </div>
                <h3 className="mb-3" style={{
              color: '#1F2937',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: '20px',
              letterSpacing: '-0.01em'
            }} data-id="element-386">
                  {card.title}
                </h3>
                <p style={{
              color: '#4F5B69',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontSize: '15px',
              lineHeight: 1.6
            }} data-id="element-387">
                  {card.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}